var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-and-contact"},_vm._l((_vm.links),function(link,index){return _c('FooterLink',{key:("footer-link-" + index),staticClass:"help-and-contact__link",attrs:{"label":_vm.$t(link.label),"target":link.url}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }